/*  MUI  */
import { Alert, Box, Typography } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const IntegrationDescription = () => {
    const { t } = useTranslation();

    return (
        <Box margin="24px">
            <Alert severity="info" icon={false}>
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Clients.add_notice')
                    }}
                />
            </Alert>
        </Box>
    );
};
